import { render, staticRenderFns } from "./personDialog.vue?vue&type=template&id=151a053f&"
import script from "./personDialog.vue?vue&type=script&lang=js&"
export * from "./personDialog.vue?vue&type=script&lang=js&"
import style0 from "./personDialog.vue?vue&type=style&index=0&id=151a053f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports